<!-- Job summary for clients -->
<div
  *ngIf="job && accountService.userIs('consumer')"
  class="mable-section"
>
  <ng-container *ngIf="defaultServiceCategory$ | async as defaultServiceCategory">
    <app-rates-info-banner
      *ngIf="defaultServiceCategory?.length && shouldShowRatesInfoBanner"
      [isCarer]="isCarer"
    ></app-rates-info-banner>
  </ng-container>
  <div class="sub-section">
    <mable-heading heading="h5">{{ job?.title }}</mable-heading>

    <div>
      <div class="ion-margin-horizontal services">
        <div class="properties">
          <ion-icon name="location"></ion-icon>
          <p class="text">{{ job?.location?.address }}</p>
        </div>
        <app-flex-job-date-time
          [job]="job"
          class="properties"
        ></app-flex-job-date-time>
        <div
          class="properties"
          *ngIf="job?.serviceCategories?.length"
        >
          <ion-icon name="list"></ion-icon>
          <div [class.unqualified]="accountService.userIs('carer') && !job?.workerFields?.isQualified">
            <p
              class="text"
              *ngFor="let service of job?.serviceCategories"
            >
              {{ service?.name }}
            </p>
          </div>
        </div>
        <!-- Rate budget support types -->
        <ng-container *ngIf="defaultServiceCategory$ | async as defaultServiceCategory">
          <app-support-service-types
            *ngIf="defaultServiceCategory?.length"
            [budgetSupportTypes]="defaultServiceCategory"
            [isLastMinuteJob]="true"
          />
        </ng-container>
        <div
          class="properties"
          *ngIf="job?.preferredWorker?.gender"
        >
          <ion-icon [name]="job.preferredWorker.gender"></ion-icon>
          <p
            class="text"
            [class.unqualified]="accountService.userIs('carer') && !job?.workerFields?.isQualified"
          >
            {{ job?.preferredWorker?.gender }} workers only
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="sub-section">
    <mable-heading heading="h5">Activities</mable-heading>
    <p class="ion-margin-horizontal white-space-pre-wrap">{{ job?.jobDescription }}</p>
  </div>

  <div
    class="sub-section"
    *ngIf="job.participant && job.participant.aboutSocialNeeds"
  >
    <mable-heading heading="h5">About Me - {{ job.participant.displayFirstName }}</mable-heading>
    <p class="ion-margin-horizontal white-space-pre-wrap">{{ job.participant.aboutSocialNeeds }}</p>
  </div>
</div>
<!-- Job summary for workers -->
<div
  class="mable-section"
  *ngIf="job && accountService.userIs('carer')"
>
  <div class="sub-section ion-margin-horizontal">
    <app-job-status-chips [job]="job"></app-job-status-chips>
  </div>
  <div class="sub-section">
    <mable-heading heading="h3">{{ job.title }}</mable-heading>
  </div>
  <ng-container *ngIf="defaultServiceCategory$ | async as defaultServiceCategory">
    <app-rates-info-banner
      *ngIf="defaultServiceCategory?.length && shouldShowRatesInfoBanner"
      [isCarer]="isCarer"
    ></app-rates-info-banner>
  </ng-container>
  <div class="sub-section">
    <div class="ion-margin-horizontal services">
      <div class="properties">
        <ion-icon name="location"></ion-icon>
        <p class="text">{{ job?.location?.address }}</p>
      </div>
      <app-flex-job-date-time
        [job]="job"
        class="properties"
      ></app-flex-job-date-time>
      <div
        class="properties"
        *ngIf="job?.serviceCategories?.length"
      >
        <ion-icon name="list"></ion-icon>
        <div [class.unqualified]="accountService.userIs('carer') && !job?.workerFields?.isQualified">
          <p
            *ngFor="let service of job.serviceCategories"
            class="text"
          >
            {{ service?.name }}
          </p>
        </div>
      </div>
      <!-- Rate budget support types -->
      <ng-container *ngIf="defaultServiceCategory$ | async as defaultServiceCategory">
        <app-support-service-types
          *ngIf="defaultServiceCategory?.length"
          [budgetSupportTypes]="defaultServiceCategory"
          [isLastMinuteJob]="true"
        />
      </ng-container>
      <div
        class="properties"
        *ngIf="job?.preferredWorker?.gender"
      >
        <ion-icon [name]="job.preferredWorker.gender"></ion-icon>
        <p
          class="text"
          [class.unqualified]="accountService.userIs('carer') && !job?.workerFields?.isQualified"
        >
          {{ job.preferredWorker.gender }} support preferred
        </p>
      </div>
    </div>
  </div>
  <div class="sub-section">
    <mable-heading heading="h3">Activities</mable-heading>
    <p class="ion-margin-horizontal white-space-pre-wrap">{{ job?.jobDescription }}</p>
  </div>
  <div
    *ngIf="job.participant && job.participant.aboutSocialNeeds"
    class="sub-section"
  >
    <mable-heading heading="h3">About Me - {{ job.participant.displayFirstName }}</mable-heading>
    <p class="ion-margin-horizontal white-space-pre-wrap">{{ job.participant.aboutSocialNeeds }}</p>
  </div>
</div>
<ion-toolbar *ngIf="showCancel()">
  <ion-grid>
    <ion-row>
      <ion-col>
        <mable-button
          expand="block"
          category="outline"
          (onClick)="cancelBooking()"
          >Cancel job</mable-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-toolbar>
